import React, { Suspense, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'
import { history } from '../../_redux/_store/history'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import {
  Grid,
  Tooltip,
  Button,
  TextField,
  Divider,
  Snackbar,
} from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { makeStyles, mergeClasses } from '@material-ui/styles'
import HelpBlockImg from '../../_assets/_images/helpBlock.png'
import ErrorHandler from '../updateHandlers/ErrorHandler'
import SkeletonPaper from '../skeleton/SkeletonPaper.jsx'
import {
  clearScopedAnomalyState,
  deleteScopedAnomalyRule,
  fetchScopedAnomalyRule,
  updateScopedAnomalyRule,
} from '../../_redux/_actions/scopedAnomalyRuleActions'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { DeleteConfirmDialog } from '../updateHandlers/DeleteDialog'
import { SuccessDialog } from '../updateHandlers/MessageDialog'
import useDebounce from '../../utilities/useDebounce'
import { fetchSpecificAnomalyRule } from '../../_redux/_actions/selectScopedAnomalyRuleAction'
import { BreadcrumbDispatch } from '../../App'

const useStyles = makeStyles(() => ({
  detailsPaper: {
    // width: "1090px",
    // height: "120px",
    margin: '40px 0px',
    backgroundColor: '#F6F6F6',
    padding: '30px 0px 30px 15px',

    width: '100%',
  },
  containerPaper: {
    // width: "1170px",
    minHeight: '962px',
    padding: '30px',
    opacity: '1',
  },
  descTitle: {
    marginTop: '30px',
  },
  decimalCard: {
    height: '250px',
    overflowY: 'scroll',
  },
  stringCard: {
    height: '210px',
    overflowY: 'scroll',
  },
  decimal: {
    fontSize: '34.74px',
  },
  string: {
    marginBottom: '30px',
  },
  cardHeader: {
    backgroundColor: '#e7e1e1',
  },
  separator: {
    margin: '8px 15px',
    flexBasis: 0,
  },
  label: {
    width: '88px',
  },
  icon: {
    color: '#ACACAC',
    margin: '5px',
  },
  editButton: {
    color: '#52A1C2',
  },
  deleteButton: {
    background: 'white',
    color: 'black',
  },
  textEditButton: {
    color: 'blue',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
}))

const ScopedAnomalyRuleConfigurationComponent = React.memo(() => {
  const classes = useStyles()
  const anomalyRuleResponse = useSelector((state) => state.detailsPersist)
  const [scopedAnomalyRule, setScopedAnomalyRule] = useState('')
  const [textEdit, setTextEdit] = useState(false)
  const [paramEdited, setParamEdited] = useState(false)
  const [note, setNote] = useState()
  const [unbranded, setUnbranded] = useState()
  const [open, setOpen] = useState(false)
  const [error, setError] = useState('')
  const dispatch = useDispatch()
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues;
  const anomalyRuleId = queryValues.anomalyRuleId
  const scope = queryValues.scope
  const scopedAnomalyRuleResponse = useSelector(
    (state) => state.scopedAnomalyRule
  )
  const selectScopedAnomalyRuleResponse = useSelector(
    (state) => state.selectScopedAnomalyRule
  );
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false)
  const debounce = useDebounce()

  useEffect(() => {
    dispatch(fetchSpecificAnomalyRule(anomalyRuleId, machine_type, hmi_type)).then(()=>dispatch(
      fetchScopedAnomalyRule({
        anomaly_rule_id: anomalyRuleId,
        scope: scope,
        machine_type: machine_type,
        hmi_type:hmi_type,
        with_parameters: true,
      })
    ))

    return () => {
      dispatch(clearScopedAnomalyState())
    }
  }, [])

  useEffect(() => {
    if (scopedAnomalyRuleResponse.scopedAnomalyRule) {
      if (scopedAnomalyRuleResponse.scopedAnomalyRule.length > 0) {
        setScopedAnomalyRule(scopedAnomalyRuleResponse.scopedAnomalyRule[0])
        setNote(scopedAnomalyRuleResponse.scopedAnomalyRule[0].note_text)
        setUnbranded(
          scopedAnomalyRuleResponse.scopedAnomalyRule[0].parameters.unbranded
        )
      }
    }
  }, [scopedAnomalyRuleResponse.scopedAnomalyRule])

  useEffect(() => {
    if (scopedAnomalyRuleResponse.deleteSuccess) {
      history.push(`/rules/select_anomaly_rule/select_scoped_anomaly_rule?machine_type=${machine_type}&hmi_type=${hmi_type}&anomalyRuleId=${anomalyRuleId}`)
    }
  }, [scopedAnomalyRuleResponse.deleteSuccess])

  const updateNote = () => {
    if (scopedAnomalyRule.note_text !== note.trim()) {
      const body = {
        anomaly_rule_id: anomalyRuleId,
        scope: scope,
        parameters: scopedAnomalyRule.parameters,
        note_text: note,
      }
      dispatch(updateScopedAnomalyRule(body, machine_type,hmi_type, setUpdateDialogOpen))
      debounce(() =>
        dispatch(
          fetchScopedAnomalyRule({
            anomaly_rule_id: anomalyRuleId,
            scope: scope,
            with_parameters: true,
            machine_type: machine_type,
            hmi_type:hmi_type
          })
        )
      )
    }
    setTextEdit(false)
  }
  const handleUpdateSuccess = () => {
    dispatch(
      fetchScopedAnomalyRule({
        anomaly_rule_id: anomalyRuleId,
        scope: scope,
        with_parameters: true,
        machine_type: machine_type,
        hmi_type:hmi_type
      })
    )
    setUpdateDialogOpen(true)
  }

  const handleDelete = () => {
    const body = { anomaly_rule_id: anomalyRuleId, scope: scope }
    dispatch(deleteScopedAnomalyRule(body, machine_type, hmi_type))
  }

  const updateParameter = (parameter, unbrandedProp) => {
    const paramValue = unbrandedProp
      ? unbrandedProp[[parameter.name]]
      : unbranded[[parameter.name]]
    if (
      paramValue !== scopedAnomalyRule.parameters.unbranded[[parameter.name]]
    ) {
      if (!parameter.optional && !paramValue) {
        setError(`Enter parameter value`)
        return
      }

      if (paramValue && typeof paramValue === 'number') {
        if (
          parameter.type === 'integer' &&
          paramValue.toString().match(/-?[0-9]+/)[0] !== paramValue.toString()
        ) {
          //to check if integer
          setError(`Parameter value must be integer`)
          return
        } else if (
          //to check if decimal
          parameter.type === 'decimal' &&
          paramValue.toString().match(/-?[0-9]+([\.][0-9]+)?/)[0] !=
            paramValue.toString()
        ) {
          setError(`Parameter value must be decimal`)
          return
        }
      }
      if (!error) {
        const paramObj = {}
        paramObj[[parameter.name]] = paramValue
        const body = {
          anomaly_rule_id: anomalyRuleId,
          scope: scope,
          parameters: {
            unbranded: paramObj,
          },
        }

        dispatch(updateScopedAnomalyRule(body, machine_type,hmi_type, handleUpdateSuccess))
      }
    }
    setParamEdited(false)
  }

  const handleConfirm = () => {
    setOpen(!open)
  }

  const handleUpdateDialog = () => {
    setUpdateDialogOpen(false)
  }

  return (
    <Grid container spacing={3}>
      <BreadcrumbDispatch />
      <Grid item md={9}>
        {scopedAnomalyRuleResponse.error && (
          <ErrorHandler message={scopedAnomalyRuleResponse.error} />
        )}
        {/* {error && <ErrorHandler message={error} />} */}
        <Snackbar
          message={error}
          open={error ? true : false}
          onClose={() => setError(false)}
          // autoHideDuration={2000}
        />
        <Paper className={classes.containerPaper}>
          <Grid container>
            <Grid item>
              <Typography className='text-secondary' variant='h5'>
                Scoped Anomaly Rule Configuration
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip title='question'>
                <HelpOutlineIcon className={classes.icon} />
              </Tooltip>
            </Grid>
          </Grid>
          <Paper className={classes.detailsPaper} elevation={0}>
            {scopedAnomalyRuleResponse.loading && <SkeletonPaper row={2} />}
            {scopedAnomalyRule && (
              <Grid container direction='column' spacing={2}>
                { selectScopedAnomalyRuleResponse.specificAnomalyRule &&
                    selectScopedAnomalyRuleResponse.specificAnomalyRule
                    .map((anomaly,id) => (
                      <React.Fragment key={`anomaly-${id}`}>
                        <Grid item container key="type">
                          <Grid item xs={3}>
                            <Typography variant='subtitle2'>
                              Anomaly Type
                            </Typography>
                          </Grid>
                          <Grid item xs={1}>
                            -
                          </Grid>
                          <Grid item xs={4}>
                            <Typography
                              
                              className='black-text wordBreak'
                            >
                              {anomaly.anomaly_type_id}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'center' }}>
                            <Button
                              variant='outlined'
                              className='btn-white'
                              onClick={handleConfirm}
                            >
                              DELETE SCOPED ANOMALY RULE
                            </Button>
                          </Grid>
                        </Grid>
                        <Grid item container key="signal">
                          <Grid item xs={3}>
                            <Typography variant='subtitle2'>Signals</Typography>
                          </Grid>
                          <Grid item xs={1}>
                            -
                          </Grid>
                          <Grid item xs={8}>
                            {anomaly.signals &&
                              anomaly.signals.map((row, id) => (
                                <Typography
                                  key={`anomalySignal=${id}`}
                                  
                                  className='black-text wordBreak'
                                >
                                  ID: {row.id} <br/> Name: {row.name}
                                </Typography>
                              ))}
                          </Grid>
                        </Grid>
                        <Grid item container key="scope">
                          <Grid item xs={3}>
                            <Typography variant='subtitle2'>
                              Scope
                            </Typography>
                          </Grid>
                          <Grid item xs={1}>
                            -
                          </Grid>
                          <Grid item xs={4}>
                            <Typography  className='black-text'>
                              {scopedAnomalyRule.scope}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item container ket="note">
                          <Grid item xs={3}>
                            <Typography variant='subtitle2'>
                              Note Text
                            </Typography>
                          </Grid>
                          <Grid item xs={1}>
                            -
                          </Grid>
                          <Grid item container xs={8}>
                            {!textEdit ? (
                              <>
                                <Typography  className='black-text'>
                                  {scopedAnomalyRule.note_text
                                    ? scopedAnomalyRule.note_text
                                    : ''}
                                </Typography>
                                <Button
                                  style={{ marginLeft: 0 }}
                                  onClick={() => setTextEdit(true)}
                                  className={classes.textEditButton}
                                >
                                  <Typography variant='caption'>
                                    Edit
                                  </Typography>
                                </Button>
                              </>
                            ) : (
                              <>
                                <TextField
                                  value={note}
                                  onChange={(e) => setNote(e.target.value)}
                                  // InputProps={{ disableUnderline: true }}
                                ></TextField>
                                <Button
                                  style={{ marginLeft: 0 }}
                                  onClick={(e) => updateNote(e.target.value)}
                                  className={classes.textEditButton}
                                >
                                  <Typography variant='caption'>
                                    Save
                                  </Typography>
                                </Button>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    ))}
              </Grid>
            )}
            <DeleteConfirmDialog
              open={open}
              handleDelete={handleDelete}
              message={' Do you want to delete this Scoped Anomaly Rule?'}
              handleConfirm={handleConfirm}
            />
            <SuccessDialog
              isSuccess={updateDialogOpen}
              message={'Data updated successfully'}
              handleSuccessDialog={handleUpdateDialog}
            />
          </Paper>

          {scopedAnomalyRule && (
            <Grid container spacing={3}>
              {scopedAnomalyRule.anomalyRule &&
                scopedAnomalyRule.anomalyRule.anomalyType &&
                scopedAnomalyRule.anomalyRule.anomalyType.anomalyTypeParameters &&
                scopedAnomalyRule.anomalyRule.anomalyType.anomalyTypeParameters.map(
                  (parameter, index) => {
                    return (
                      <Grid
                        key={`parameter-${index}`}
                        item
                        xs={12}
                      >
                        <Card>
                          <CardHeader
                            className={classes.cardHeader}
                            //   avatar={<Avatar aria-label="recipe">R</Avatar>}
                            title={parameter.name}
                            titleTypographyProps={{ variant: 'h6' }}
                            // subheader="September 14, 2016"
                          />
                          <div>
                            <CardContent
                              className={
                                parameter.type === 'string'
                                  ? classes.stringCard
                                  : classes.decimalCard
                              }
                            >
                              <Grid container direction='column'>
                                <Grid item>
                                  {parameter.type === 'boolean' ? (
                                    <>
                                      <FormGroup row>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                unbranded[parameter.name] ? true : false
                                              }
                                              onChange={(e) => {
                                                e.persist()
                                                setUnbranded({
                                                  ...unbranded,
                                                  [parameter.name]:
                                                    e.target.checked,
                                                })
                                                updateParameter(parameter, {
                                                  ...unbranded,
                                                  [parameter.name]:
                                                    e.target.checked,
                                                })
                                              }}
                                              color='primary'
                                            />
                                          }
                                          label='true'
                                        />
                                      </FormGroup>
                                    </>
                                  ) : (
                                    <>
                                      <TextField
                                        InputProps={{
                                          readOnly:
                                            parameter.name !== paramEdited,
                                        }}
                                        fullWidth={parameter.type === 'string'}
                                        required={!parameter.optional}
                                        onChange={(e) => {
                                          setUnbranded({
                                            ...unbranded,
                                            [parameter.name]: [
                                              'decimal',
                                              'integer',
                                            ].includes(parameter.type)
                                              ? Number(e.target.value)
                                              : e.target.value,
                                          })
                                        }}
                                        type={
                                          ['decimal', 'integer'].includes(
                                            parameter.type
                                          )
                                            ? 'number'
                                            : ''
                                        }
                                        defaultValue={
                                          unbranded[[parameter.name]]
                                        }
                                      />
                                      {parameter.name === paramEdited ? (
                                        <Button
                                          style={{ marginLeft: 0 }}
                                          onClick={() => {
                                            updateParameter(parameter)
                                          }}
                                          className={classes.textEditButton}
                                        >
                                          <Typography variant='caption'>
                                            Save
                                          </Typography>
                                        </Button>
                                      ) : (
                                        <Button
                                          name={index}
                                          style={{ marginLeft: 0 }}
                                          onClick={() => {
                                            setParamEdited(parameter.name)
                                          }}
                                          className={classes.textEditButton}
                                        >
                                          <Typography variant='caption'>
                                            Edit
                                          </Typography>
                                        </Button>
                                      )}
                                    </>
                                  )}
                                </Grid>
                                <Grid item className={classes.descTitle}>
                                  <Typography variant='h6' gutterBottom>
                                    Description
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Paper elevation={0}>
                                    <Typography variant='subtitle2'>
                                      {parameter.description}
                                    </Typography>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </div>{' '}
                        </Card>
                      </Grid>
                    )
                  }
                )}
            </Grid>
          )}
        </Paper>
      </Grid>
      <Grid item md={3} className='helpBlock'>
        <Paper className={classes.containerPaper}>
          <Box component='div' className='helpBlockTitle'>
            Help
          </Box>

          <Box component='div' className='helpBlockImg'>
            <img
              src={HelpBlockImg}
              alt='HelpBlockImg'
              className='img-fluid'
              style={{ display: 'block', margin: 'auto', width: '100%' }}
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
})

export default function ScopedAnomalyRuleConfiguration() {

  useEffect(()=>{
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
  },[])
  
  return (
    <Suspense fallback=''>
      <ScopedAnomalyRuleConfigurationComponent />
    </Suspense>
  )
}
